import { Utils } from 'common';

const { Communication } = Utils;

export default class ProductsCommunication extends Communication {
	static init(params) {
		Communication.init(params);
	}

	/**
	 * Add Category
	 * @param {object} data category data
	 */
	static async addCategory(data) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/ssapi/ProductCategory`,
			data,
		});
	}

	/**
	 * Add a new product
	 * @param {Product} product
	 */
	static async addProduct(product) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/ssapi/Products?applyToPending=false`,
			data: product,
		});
	}

	/**
	 * Delete Category
	 * @param {number} categoryId
	 */
	static async deleteCategory(categoryId) {
		return this.axiosRequest({
			method: 'delete',
			url: `${this.accountApiUrlPrefix}/ssapi/ProductCategory/${categoryId}`,
			data: {},
		});
	}

	/**
	 * Get products
	 * @param {string} queryString
	 * @return {object}
	 */
	static async getProducts(queryString) {
		return this.axiosRequest({
			method: 'get',
			url: `${this.accountApiUrlPrefix}/ssapi/Products?${queryString}`,
		});
	}

	/**
	 * Get Product Categories
	 */
	static async getProductCategory() {
		return this.axiosRequest({
			url: `${this.accountApiUrlPrefix}/ssapi/ProductCategory?includeCounts=true&page=1&pagesize=500`,
		});
	}

	/**
	 * Update products
	 * @param {Product} product
	 */
	static async updateProduct(product) {
		return this.axiosRequest({
			method: 'put',
			url: `${this.accountApiUrlPrefix}/ssapi/Products/${product.ProductID}?applyToPending=false`,
			data: product,
		});
	}

	/**
	 * Update Multiple products
	 * @param {array} products
	 */
	static async updateMultiple(products) {
		return this.axiosRequest({
			method: 'post',
			url: `${this.accountApiUrlPrefix}/ssapi/Products/UpdateMultiple`,
			data: products,
		});
	}

	/**
	 * Update Category
	 * @param {object} data category data
	 */
	static async updateCategory(data) {
		return this.axiosRequest({
			method: 'put',
			url: `${this.accountApiUrlPrefix}/ssapi/ProductCategory/${data.CategoryID}`,
			data,
		});
	}
}
